import { Transmit } from '@adonisjs/transmit-client';
import { tokenManager } from './token-manager';

let notificationsTransmitInstance: Transmit | null = null;

function applyAuthHeader(request: Request): void {
  const authHeader = tokenManager.getAuthorizationHeader();
  if (authHeader) {
    request.headers.set('Authorization', authHeader);
  }
}

export function getNotificationsTransmitClient(): Transmit {
  if (!notificationsTransmitInstance) {
    const baseUrl = import.meta.env.VITE_API_URL || 'https://api.fluenceur.local';

    notificationsTransmitInstance = new Transmit({
      baseUrl,
      beforeSubscribe: applyAuthHeader,
      beforeUnsubscribe: applyAuthHeader,
    });
  }

  return notificationsTransmitInstance;
}

export function resetNotificationsTransmitClient(): void {
  if (notificationsTransmitInstance) {
    notificationsTransmitInstance.close();
  }
  notificationsTransmitInstance = null;
}
